import React from "react";
import {Button, Checkbox, Form, Input, Menu} from "antd";
import {
    PieChartOutlined,
    UserOutlined,
    DashboardOutlined,
    RightOutlined,
    CalendarOutlined,
    BarsOutlined,
    BulbOutlined, LockOutlined,
} from '@ant-design/icons';
import './Login.less';
import Card from "./views/Card";
import Server from "../helpers/Server";
import SystemFunctions from "../helpers/SystemFunctions";

export default class Login extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            screen: 'dashboard',
            leftRouterState: false,
            errorUsername: '',
            errorPassword: '',
            loading: false,
        };
    }

    componentDidMount() {

    }

    render() {
        return (
            <div className='Login'>
                <div className='authForm'>
                    <div className='pageTitle'>Авторизация</div>
                    <Card>
                        <Form name="login"
                              className="loginForm"
                              initialValues={{remember: true}}
                              onFinish={this.onLogin}>
                            <Form.Item name="username"
                                       style={{marginBottom: '12px'}}
                                       validateStatus={this.state.errorUsername === '' ? null : 'error'}
                                       help={this.state.errorUsername === '' ? null : this.state.errorUsername}
                                       onChange={(e) => {
                                           if (this.state.errorUsername != ''){
                                               this.setState({
                                                   errorUsername: ''
                                               });
                                               if (this.state.errorPassword != ''){
                                                   this.setState({
                                                       errorPassword: ''
                                                   });
                                               }
                                           }
                                       }}>
                                <Input prefix={<UserOutlined className="site-form-item-icon"/>} placeholder="Username"/>
                            </Form.Item>
                            <Form.Item name="password"
                                       style={{marginBottom: '12px'}}
                                       validateStatus={this.state.errorPassword === '' ? null : 'error'}
                                       help={this.state.errorPassword === '' ? null : this.state.errorPassword}>
                                <Input prefix={<LockOutlined className="site-form-item-icon"/>}
                                       type="password"
                                       onChange={(e) => {
                                           if (this.state.errorPassword != ''){
                                               this.setState({
                                                   errorPassword: ''
                                               });
                                               if (this.state.errorUsername != ''){
                                                   this.setState({
                                                       errorUsername: ''
                                                   });
                                               }
                                           }
                                       }}
                                       placeholder="Password"/>
                            </Form.Item>
                            <Form.Item style={{marginBottom: 0}}>
                                <Button type="default" htmlType="submit" className="loginButton" loading={this.state.loading}>
                                    Войти
                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </div>
            </div>
        );
    }

    onLogin = (data) => {
        let login = data.username;
        let password = data.password;
        if (login == null || login.trim() == ''){
            this.setState({
                errorUsername: "Вы не ввели username!",
            });
            return;
        }
        if (password == null || password.trim() == ''){
            this.setState({
                errorPassword: "Вы не ввели пароль!",
            });
            return;
        }
        login = login.trim();
        password = password.trim();
        this.setState({loading: true});
        Server.auth(login, password, (response) => {
            let r = response.data;
            if (r.status){
                SystemFunctions.saveStorage('user_id', r.uid);
                SystemFunctions.saveStorage('session_id', r.sid);
                SystemFunctions.saveStorage('session_token', r.token);
                Server.user_id = r.uid;
                Server.session_id = r.sid;
                Server.session_token = r.token;
                this.setState({
                    loading: false,
                });
                this.props.go('main');
            } else {
                if (r.code === 10){
                    this.setState({
                        errorPassword: r.error,
                        errorUsername: r.error,
                        loading: false,
                    });
                } else if (r.code === 1){
                    this.setState({
                        errorUsername: r.error,
                        loading: false,
                    });
                } else {
                    this.setState({
                        errorPassword: r.error,
                        loading: false,
                    });
                }
            }
        }, (error) => {
            this.setState({
                errorPassword: "Ошибка подключения к серверу. Попробуйте очистить кеш и перезагрузить страницу.",
                loading: false,
            });
        });
    }
}